<template>
    <svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0">
        <linearGradient :id="id" x1="0" y1="10" x2="40" y2="10" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="#FF8057"></stop>
            <stop offset="50%" stop-color="#FF27CC"></stop>
            <stop offset="100%" stop-color="#FF8057"></stop>
            <animate attributeName="x1" values="0;-20;0" dur="6s" calcMode="spline" keySplines="0.42 0 0.58 1; 0.42 0 0.58 1" repeatCount="indefinite"></animate>
            <animate attributeName="x2" values="40;20;40" dur="6s" calcMode="spline" keySplines="0.42 0 0.58 1; 0.42 0 0.58 1" repeatCount="indefinite"></animate>
        </linearGradient>
        <path
            d="M10 0C11.1046 1.61064e-07 12.4004 4.47715 12.4004 10C12.4004 15.5228 11.1046 20 10 20C8.89543 20 7.59961 15.5228 7.59961 10C7.59961 4.47715 8.89543 0 10 0ZM5.2998 1C6.12823 1 7 5.02944 7 10C7 14.9706 6.12823 19 5.2998 19C4.47144 18.9994 3.59961 14.9702 3.59961 10C3.59961 5.02983 4.47144 1.00063 5.2998 1ZM14.7002 1C15.5286 1.00063 16.4004 5.02983 16.4004 10C16.4004 14.9702 15.5286 18.9994 14.7002 19C13.8718 19 13 14.9706 13 10C13 5.02944 13.8718 1 14.7002 1ZM2 4.40039C2.55228 4.40039 3 6.90721 3 10C3 13.0928 2.55228 15.5996 2 15.5996C1.44772 15.5996 1 13.0928 1 10C1 6.90721 1.44772 4.40039 2 4.40039ZM18 4.40039C18.5523 4.40039 19 6.90721 19 10C19 13.0928 18.5523 15.5996 18 15.5996C17.4477 15.5996 17 13.0928 17 10C17 6.90721 17.4477 4.40039 18 4.40039Z"
            :fill="`url(#${id})`"></path>
    </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

const id = useId();
</script>
